export default __webpack_public_path__ + "static/media/projectCardBg.c5610e7a.jpeg";